import { AssessmentRepository } from 'application/repositories/AssessmentRepository';
import {
    AssessmentDetailResponse,
    AssessmentSimple,
    AssessmentSimpleResponse,
} from 'domain/entities/AssessmentEntity';
import { DataProperty, ParamsProperty } from 'domain/entities/PropertyEntity';
import axiosConfig from 'infrastructure/config/axios';
import { commonHelpers } from 'utilities/helpers';

export class AssessmentAPI implements AssessmentRepository {
    async getAssessmentDetail(params: {
        listedPropertyId: number;
    }): Promise<AssessmentDetailResponse> {
        const API_URL = '/assessment/detail';
        const response = await axiosConfig.getAxiosConfig().get(API_URL, { params });
        return response.data;
    }

    async getListPropertyAssessment(params: ParamsProperty): Promise<DataProperty[]> {
        const API_URL = '/assessment/list';
        const response = await axiosConfig.getAxiosConfig().get(API_URL, { params });
        return response.data;
    }

    async putAssessmentSimpleData(params: AssessmentSimple): Promise<AssessmentSimpleResponse> {
        const API_URL = 'assessment/simple';
        const formData = commonHelpers.convertObjectToFormData({
            age_building: params.age_building,
            area: params.area,
            station_cd: params.station_cd,
            on_foot_time: params.on_foot_time,
            rent_price: params.rent_price,
            repair_fund: params.repair_fund,
        });
        const response = await axiosConfig.getAxiosConfig().post(API_URL, formData);
        return response.data;
    }
}
